// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * NotificationPermissionBanner Styles
 *
 * Matches the UpdateNotification component theme with gradient background,
 * red primary button, and consistent styling.
 */

.notification-permission-banner {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  width: min(600px, calc(100% - 48px));
  animation: notificationSlideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: auto;
}

@keyframes notificationSlideDown {
  from {
    transform: translate(-50%, -120px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.notification-permission-banner-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-radius: 16px;
  background: linear-gradient(
    26deg,
    #000000 0%,
    #4a4a4a 34%,
    #de4858 100%
  );
  color: #ffffff;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
}

.notification-permission-banner .banner-icon {
  flex-shrink: 0;
  font-size: 32px;
  color: #ffffff;
}

.notification-permission-banner .banner-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notification-permission-banner .banner-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.01em;
  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;
}

.notification-permission-banner .banner-description {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  opacity: 0.9;
  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;
}

.notification-permission-banner-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.notification-permission-banner .banner-dismiss-btn,
.notification-permission-banner .banner-enable-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: -0.01em;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  font-family: 'SF Pro Text', 'Noto Sans', 'Segoe UI', sans-serif;
}

.notification-permission-banner .banner-dismiss-btn {
  background: transparent;
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.notification-permission-banner .banner-dismiss-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.notification-permission-banner .banner-enable-btn {
  background: #de4858;
  color: #ffffff;
}

.notification-permission-banner .banner-enable-btn:hover {
  filter: brightness(1.1);
}

.notification-permission-banner .banner-dismiss-btn:focus-visible,
.notification-permission-banner .banner-enable-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: 2px;
}

/* Responsive design for mobile */
@media (max-width: 640px) {
  .notification-permission-banner {
    top: 16px;
    width: min(100%, calc(100% - 32px));
  }

  .notification-permission-banner-content {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px 20px;
    text-align: center;
  }

  .notification-permission-banner .banner-icon {
    align-self: center;
  }

  .notification-permission-banner-actions {
    flex-direction: column;
    width: 100%;
  }

  .notification-permission-banner .banner-dismiss-btn,
  .notification-permission-banner .banner-enable-btn {
    width: 100%;
  }
}

/* Accessibility: Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .notification-permission-banner {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .notification-permission-banner .banner-dismiss-btn,
  .notification-permission-banner .banner-enable-btn {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationPermissionBanner.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,oCAAoC;EACpC,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA;EACE;IACE,kCAAkC;IAClC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB;;;;;GAKC;EACD,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE;IACE,SAAS;IACT,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * NotificationPermissionBanner Styles\n *\n * Matches the UpdateNotification component theme with gradient background,\n * red primary button, and consistent styling.\n */\n\n.notification-permission-banner {\n  position: fixed;\n  top: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  width: min(600px, calc(100% - 48px));\n  animation: notificationSlideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  pointer-events: auto;\n}\n\n@keyframes notificationSlideDown {\n  from {\n    transform: translate(-50%, -120px);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n.notification-permission-banner-content {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 24px;\n  border-radius: 16px;\n  background: linear-gradient(\n    26deg,\n    #000000 0%,\n    #4a4a4a 34%,\n    #de4858 100%\n  );\n  color: #ffffff;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n}\n\n.notification-permission-banner .banner-icon {\n  flex-shrink: 0;\n  font-size: 32px;\n  color: #ffffff;\n}\n\n.notification-permission-banner .banner-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.notification-permission-banner .banner-title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: -0.01em;\n  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;\n}\n\n.notification-permission-banner .banner-description {\n  font-size: 14px;\n  line-height: 1.4;\n  font-weight: 400;\n  opacity: 0.9;\n  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;\n}\n\n.notification-permission-banner-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.notification-permission-banner .banner-dismiss-btn,\n.notification-permission-banner .banner-enable-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n  font-family: 'SF Pro Text', 'Noto Sans', 'Segoe UI', sans-serif;\n}\n\n.notification-permission-banner .banner-dismiss-btn {\n  background: transparent;\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.8);\n}\n\n.notification-permission-banner .banner-dismiss-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.notification-permission-banner .banner-enable-btn {\n  background: #de4858;\n  color: #ffffff;\n}\n\n.notification-permission-banner .banner-enable-btn:hover {\n  filter: brightness(1.1);\n}\n\n.notification-permission-banner .banner-dismiss-btn:focus-visible,\n.notification-permission-banner .banner-enable-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.6);\n  outline-offset: 2px;\n}\n\n/* Responsive design for mobile */\n@media (max-width: 640px) {\n  .notification-permission-banner {\n    top: 16px;\n    width: min(100%, calc(100% - 32px));\n  }\n\n  .notification-permission-banner-content {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    padding: 16px 20px;\n    text-align: center;\n  }\n\n  .notification-permission-banner .banner-icon {\n    align-self: center;\n  }\n\n  .notification-permission-banner-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .notification-permission-banner .banner-dismiss-btn,\n  .notification-permission-banner .banner-enable-btn {\n    width: 100%;\n  }\n}\n\n/* Accessibility: Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .notification-permission-banner {\n    animation: fadeIn 0.3s ease-in;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .notification-permission-banner .banner-dismiss-btn,\n  .notification-permission-banner .banner-enable-btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
